import React, { useState } from 'react';
import { Modal, Icon, Checkbox } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SHOW_NO_MORE_INFO_MODAL } from '../../constants/common';
import { setInfoModalVisible } from '../../store/actions/calendarActions';
import cn from 'classnames';
import styles from './InfoModal.module.scss';

const InfoModal = () => {
  const dispatch = useDispatch();
  const infoModalVisible = useSelector(
    (state) => state.newCalendarStore.infoModalVisible
  );
  const itemToCalendar = useSelector((state) => state.itemToCalendarStore.item);

  const history = useHistory();

  const [showNoMore, setShowNoMore] = useState(false);

  const handleShowMoreChange = (e) => {
    setShowNoMore(e.target.checked);
  };

  const handleCancel = () => {
    dispatch(setInfoModalVisible(false));
    setShowNoMore(false);
    history.goBack();
  };

  const handleOk = () => {
    if (showNoMore) {
      try {
        localStorage.setItem(SHOW_NO_MORE_INFO_MODAL, 'true');
      } catch (error) {}
    }

    dispatch(setInfoModalVisible(false));
  };

  return (
    <Modal
      visible={infoModalVisible}
      width={460}
      title="Добавление заявки в календарь"
      okText="Добавить событие в календарь"
      wrapClassName={styles.root}
      centered
      onCancel={handleCancel}
      onOk={handleOk}
      maskClosable={false}
    >
      <div className={styles.flexColumnContainer}>
        <div className={styles.flexRowContainer}>
          <p className={cn(styles.cover, styles.text, styles.boldText)}>
            {itemToCalendar?.id || ''}
          </p>
          <p className={cn(styles.cover, styles.text)}>
            {itemToCalendar?.fullAddress || ''}
          </p>
        </div>
        {itemToCalendar?.description && (
          <p className={cn(styles.cover, styles.text, styles.fullWidth)}>
            {itemToCalendar?.description}
          </p>
        )}
      </div>
      <div
        className={cn(
          styles.cover,
          styles.warningCover,
          styles.flexRowContainer,
          styles.fullWidth
        )}
        style={{ marginTop: '24px', alignItems: 'flex-start' }}
      >
        <Icon type="warning" style={{ color: '#e41c1c', fontSize: '24px' }} />
        <p className={styles.text}>
          Чтобы добавить заявку в календарь, кликните на ячейку с нужным днем и
          временем или на кнопку «Создать»
        </p>
      </div>
      <Checkbox
        checked={showNoMore}
        style={{ marginTop: '16px' }}
        onChange={handleShowMoreChange}
      >
        Больше не показывать
      </Checkbox>
    </Modal>
  );
};

export default InfoModal;
